import { isNullish } from '@nx/stdlib';

import { LICENSE_STATE } from '../api-types';
import type { DEPLOYMENT_STATUS, LICENSE_TYPE } from '../api-types';

export interface Dbms {
  dbmsId: string;
  name: string;
  status: DEPLOYMENT_STATUS;
  tokenCreatedBy: string;
}

export interface DbmsDetails extends Dbms {
  version: string;
  edition: string;
  packaging: string;
  databases: Database[];
  servers: Server[];
  license?: License;
  bloomLicense?: License;
  gdsLicense?: License;
}

export interface Database {
  databaseId: string;
  name: string;
}

export interface Server {
  serverId: string;
  address: string;
  health: string;
  modeConstraint: string;
  version?: string;
  status: DEPLOYMENT_STATUS;
  lastPing: Date;
  databaseInstances: DatabaseInstance[];
  license?: License;
  bloomLicense?: License;
  gdsLicense?: License;
}

export interface DatabaseInstance {
  serverId: string;
  databaseName: string;
  databaseId: string;
  role: string;
  aliases: string[];
  access: string;
  requestedStatus: string;
  currentStatus: string;
  statusMessage?: string;
  default: boolean;
  currentPrimariesCount?: number;
  currentSecondariesCount?: number;
  requestedPrimariesCount?: number;
  requestedSecondariesCount?: number;
  creationTime: Date;
  lastStartTime: Date;
  store: string;
  writer: boolean;
  lastCommittedTxn?: number;
  replicationLag: number;
}

export interface License {
  type: LICENSE_TYPE;
  state: LICENSE_STATE;
  daysLeftOnTrial: number;
  totalTrialDays: number;
}

function hasLicenseIssue(license?: License): boolean {
  return (
    license?.state === LICENSE_STATE.EXPIRED ||
    license?.state === LICENSE_STATE.NOT_ACCEPTED ||
    license?.state === LICENSE_STATE.INVALID ||
    license?.state === LICENSE_STATE.INCONSISTENT
  );
}

export function hasLicenseIssues(dbms: DbmsDetails): boolean {
  return (
    isNullish(dbms.license) ||
    hasLicenseIssue(dbms.license) ||
    hasLicenseIssue(dbms.bloomLicense) ||
    hasLicenseIssue(dbms.gdsLicense)
  );
}
